<template>
  <loading v-if="!isInit" :message="'部課一覧の取得中...'"></loading>
  <template v-else>
    <label>部課を選択してください<br>※社内承認済みの雇用契約に基きます</label>
    <select v-model="selectedBuka">
      <option v-for="keiyaku in approvedKeiyakuList" :value="keiyaku"> {{ keiyaku.buka_code }}／{{ keiyaku.buka_name
      }}（雇用契約ID:{{ keiyaku.koyou_keiyaku_id }})
      </option>
      <option :value="null">部課を選択しない</option>
    </select>

    <div class="buttons">
      <div class="btn primary" v-on:click="selectBuka()">選択</div>
      <div class="btn cancel" v-on:click="cancel()">キャンセル</div>
    </div>
  </template>
</template>


<script lang="ts">
import { useKoyouKeiyakuSearch } from '@/composable/koyoukeiyaku/search';
import { useAuthStore } from '@/store/auth';
import { KeiyakuDetailWithSyuugyouBasyoAndBuka } from '@/types/KoyouKeiyaku';
import { defineComponent, onMounted, Ref, ref } from 'vue'

export default defineComponent({
  props: {
    userId: {
      type: Object as () => number | null,
      default: null
    }
  },
  emits: {
    select(value: KeiyakuDetailWithSyuugyouBasyoAndBuka | null) {
      return value
    },
    cancel() {
      return true
    }
  },
  setup(props, context) {
    const { findAllApprovedByUserId, approvedKeiyakuList } = useKoyouKeiyakuSearch()
    const isInit = ref(false)
    const selectedBuka: Ref<KeiyakuDetailWithSyuugyouBasyoAndBuka | null> = ref(null)
    const authStore = useAuthStore()

    onMounted(async () => {
      let userId = props.userId;
      if (props.userId === null && authStore.user) {
        userId = authStore.user.user_id
      }

      if (userId === null) {
        return
      }

      await findAllApprovedByUserId(userId)
      isInit.value = true
    });

    const selectBuka = async () => {
      context.emit('select', selectedBuka.value);
    };

    const cancel = () => {
      context.emit('cancel')
    }

    return {
      selectedBuka,
      approvedKeiyakuList,
      selectBuka,
      cancel,
      isInit
    }
  }
})
</script>

<style scoped>
@import '@scss/dialog/syuugyou-basyo.scss';
</style>